/* ============================================================
 * TUNExperience · Hub — fechas, horas y formato
 *
 * Las fechas se manejan siempre como texto 'YYYY-MM-DD' en horario local,
 * que es como las envía y las espera el backend. Convertirlas a Date y de
 * vuelta con toISOString() las pasa por UTC y desplaza el día: en Chile
 * (UTC-4) el 14 de agosto se convierte en el 13. De ahí localIso().
 * ============================================================ */

export const DOW = ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'];

/** Date → 'YYYY-MM-DD' en horario local, sin pasar por UTC. */
export const localIso = (d) => {
  const tz = d.getTimezoneOffset() * 60000;
  return new Date(d - tz).toISOString().slice(0, 10);
};

/** Fecha de hoy desplazada n días, como 'YYYY-MM-DD'. */
export const isoOffset = (n) => {
  const d = new Date();
  d.setDate(d.getDate() + n);
  return localIso(d);
};

export const addDaysIso = (iso, n) => {
  const d = new Date(iso + 'T00:00:00');
  d.setDate(d.getDate() + n);
  return localIso(d);
};

/** 'HH:MM' → minutos desde medianoche. */
export const toMin = (t) => {
  const p = (t || '09:00').split(':');
  return (+p[0]) * 60 + (+p[1]);
};

/** Minutos desde medianoche → 'HH:MM'. */
export const fmt = (m) =>
  String(Math.floor(m / 60)).padStart(2, '0') + ':' + String(m % 60).padStart(2, '0');

export const clp = (n) => '$' + (n || 0).toLocaleString('es-CL');

/**
 * Cómo se le cuenta al operador el historial de un cliente.
 *
 * `visitas` cuenta sesiones CUMPLIDAS, así que quien acaba de reservar por
 * primera vez tiene cero. Escribir "0ª visita" no dice nada útil a quien
 * atiende el mostrador: lo que necesita saber es si esa persona ya ha estado
 * antes en el centro.
 */
export const etiquetaVisitas = (n) => {
  if (!n) return 'Primera vez';
  if (n === 1) return 'Ha venido 1 vez';
  return `Ha venido ${n} veces`;
};

export const fechaCorta = (iso) =>
  new Date(iso + 'T00:00:00').toLocaleDateString('es-CL',
    { weekday: 'short', day: 'numeric', month: 'short' });

/** Los bloques de la jornada de una sede, como ['09:00','09:20',…]. */
export const bloquesDelDia = (apertura, cierre, bloqueMin) => {
  const salida = [];
  const fin = toMin(cierre);
  for (let m = toMin(apertura); m + (bloqueMin || 20) <= fin; m += (bloqueMin || 20)) {
    salida.push(fmt(m));
  }
  return salida;
};

/** Las próximas `count` ocurrencias de un día de la semana desde startIso. */
export const nextOccurrences = (weekday, startIso, count) => {
  const salida = [];
  const d = new Date(startIso + 'T00:00:00');
  while (d.getDay() !== weekday) d.setDate(d.getDate() + 1);
  for (let i = 0; i < count; i++) {
    salida.push(localIso(d));
    d.setDate(d.getDate() + 7);
  }
  return salida;
};
